import React from 'react';
import { Link } from 'lucide-react';

interface CallToActionEditorProps {
  settings: any;
  content: any;
  onSettingsChange: (settings: any) => void;
  onContentChange: (content: any) => void;
}

const CallToActionEditor: React.FC<CallToActionEditorProps> = ({ 
  settings, 
  content, 
  onSettingsChange, 
  onContentChange 
}) => {
  const handleSettingChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value, type } = e.target;
    const newValue = type === 'checkbox' 
      ? (e.target as HTMLInputElement).checked 
      : type === 'number' 
        ? parseInt(value) 
        : value;
    
    onSettingsChange({ [name]: newValue });
  };
  
  const handleContentChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    onContentChange({ [name]: value });
  };
  
  return (
    <div className="space-y-6">
      {/* General Settings */}
      <div className="space-y-4">
        <h3 className="text-sm font-medium text-slate-700">Genel Ayarlar</h3>
        
        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-2">
            <label className="block text-sm text-slate-600">
              Buton Metni
            </label>
            <input
              type="text"
              name="buttonText"
              value={settings?.buttonText || 'Hemen Başvur'}
              onChange={handleSettingChange}
              className="w-full px-3 py-2 border border-slate-200 rounded-lg focus:ring-2 focus:ring-[#F7BA45] focus:border-[#F7BA45]"
            />
          </div>
          
          <div className="space-y-2">
            <label className="block text-sm text-slate-600">
              Buton Rengi
            </label>
            <div className="flex gap-2">
              <input
                type="color"
                name="buttonColor"
                value={settings?.buttonColor || '#F7BA45'}
                onChange={handleSettingChange}
                className="w-10 h-10 p-1 border border-slate-200 rounded-lg"
              />
              <input
                type="text"
                name="buttonColor"
                value={settings?.buttonColor || '#F7BA45'}
                onChange={handleSettingChange}
                className="flex-1 px-3 py-2 border border-slate-200 rounded-lg focus:ring-2 focus:ring-[#F7BA45] focus:border-[#F7BA45]"
              />
            </div>
          </div>
        </div>
        
        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-2">
            <label className="block text-sm text-slate-600">
              Metin Rengi
            </label>
            <div className="flex gap-2">
              <input
                type="color"
                name="textColor"
                value={settings?.textColor || '#1e293b'}
                onChange={handleSettingChange}
                className="w-10 h-10 p-1 border border-slate-200 rounded-lg"
              />
              <input
                type="text"
                name="textColor"
                value={settings?.textColor || '#1e293b'}
                onChange={handleSettingChange}
                className="flex-1 px-3 py-2 border border-slate-200 rounded-lg focus:ring-2 focus:ring-[#F7BA45] focus:border-[#F7BA45]"
              />
            </div>
          </div>
          
          <div className="space-y-2">
            <label className="block text-sm text-slate-600">
              Arka Plan Rengi
            </label>
            <div className="flex gap-2">
              <input
                type="color"
                name="backgroundColor"
                value={settings?.backgroundColor || '#ffffff'}
                onChange={handleSettingChange}
                className="w-10 h-10 p-1 border border-slate-200 rounded-lg"
              />
              <input
                type="text"
                name="backgroundColor"
                value={settings?.backgroundColor || '#ffffff'}
                onChange={handleSettingChange}
                className="flex-1 px-3 py-2 border border-slate-200 rounded-lg focus:ring-2 focus:ring-[#F7BA45] focus:border-[#F7BA45]"
              />
            </div>
          </div>
        </div>
      </div>
      
      {/* Content */}
      <div className="space-y-4">
        <h3 className="text-sm font-medium text-slate-700">İçerik</h3>
        
        <div className="space-y-2">
          <label className="block text-sm text-slate-600">
            Başlık
          </label>
          <input
            type="text"
            name="heading"
            value={content?.heading || 'Aksiyon Çağrısı Başlığı'}
            onChange={handleContentChange}
            className="w-full px-3 py-2 border border-slate-200 rounded-lg focus:ring-2 focus:ring-[#F7BA45] focus:border-[#F7BA45]"
          />
        </div>
        
        <div className="space-y-2">
          <label className="block text-sm text-slate-600">
            Açıklama
          </label>
          <textarea
            name="description"
            value={content?.description || 'Kısa açıklama metni'}
            onChange={handleContentChange}
            rows={3}
            className="w-full px-3 py-2 border border-slate-200 rounded-lg focus:ring-2 focus:ring-[#F7BA45] focus:border-[#F7BA45]"
          />
        </div>
        
        <div className="space-y-2">
          <label className="block text-sm text-slate-600">
            Buton URL
          </label>
          <div className="relative">
            <Link className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400" size={16} />
            <input
              type="text"
              name="buttonUrl"
              value={content?.buttonUrl || '#'}
              onChange={handleContentChange}
              placeholder="https://example.com/page"
              className="w-full pl-10 pr-3 py-2 border border-slate-200 rounded-lg focus:ring-2 focus:ring-[#F7BA45] focus:border-[#F7BA45]"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CallToActionEditor;